module.exports = "<md-list-item \n  class=\"md-2-line\" \n  ng-class=\"{'disabled':song.key === $root.song.key && song.owner === $root.song.owner }\" \n  ng-repeat=\"song in vm.songs\" \n  ng-click=\"vm.select(song)\">\n  <div class=\"md-list-item-text\">\n    <h3>{{ song.name }}</h3>\n    <p>{{ song.description }}</p>\n  </div>\n</md-list-item>"


//////////////////
// WEBPACK FOOTER
// ./src/web/song/song-list.html
// module id = 183
// module chunks = 0